// extracted by mini-css-extract-plugin
export default {"container":"Series3App_container__baCAz"};